import { APIConstants, CREATE_SESSION_ACTION_TYPE } from '../../constants';
import { SSOPortalEligibilityData } from '../../dataModels/SSOPortalEligibilityData';
import axios from 'axios';

interface Params {
  refToken?: string;
  isFakeUser?: boolean;
}

export const createSsoSession = async (
  params: Params,
  config: (key: string) => string | undefined,
  useFetchUrl = false
): Promise<SSOPortalEligibilityData> => {
  try {
    const urlKey = useFetchUrl
      ? APIConstants.CONFIG.FETCH_SESSION_URL
      : APIConstants.CONFIG.SESSION_INIT_URL;
    const createSsoSessionUrl = `${config(urlKey)}`;

    const options = {
      method: 'POST',
      url: createSsoSessionUrl,
      params: {
        ...params,
        actionType: CREATE_SESSION_ACTION_TYPE.CREATE,
      },
    };
    const response = await axios(options);

    return response.data;
  } catch (error) {
    throw error;
  }
};
